<template>
	<table>
		<tr>
      		<td :colspan="treeData.children ? treeData.children.length * 2 : 1" 
			  	:class="{ parentLevel: treeData.children && checkChildrenFilters(treeData.children),
			  			  'parent-level-user': treeData.type == 'user' && treeData.children && treeData.children[0].type == 'user',
				  		  extend: treeData.children && treeData.children.length > 0 && treeData.extend && checkChildrenFilters(treeData.children) }">
				<div :class="{ node: true, 'compact': densityType == 'compact', 'detailed': densityType == 'detailed' }">
				<!-- PARENT NODE -->
					<div class="box-tbf compay-box" @click="$emit('click-node', treeData)" v-if="treeData.type == 'company'">
						<div class="content-box">
							<div class="header-box">
								<div class="box-type">
									{{$t('tree-chart.company')}}
								</div>
								<div class="box-actions">
									<v-popover class="counter" :disabled="$resize && $mq.below(780)" offset="2" trigger="hover" placement="bottom" popoverBaseClass="popover-tbf btn-animated" :delay="{show: 0, hide: 0}">
										<div class="counter"><span class="text">{{ treeData.company_people }}</span></div>

										<template slot="popover">
											<div class="simple-text">{{ $tc('tree-chart.employees',treeData.company_people) }}</div>
										</template>
									</v-popover>
								</div>
							</div>
							<div class="title-company">
								<div class="avatar">
									<img :src="treeData.company_avatar.lastIndexOf('gravatar') >= 0 ? treeData.company_avatar : `/build${treeData.company_avatar.substring(treeData.company_avatar.lastIndexOf('.ro')+3)}`" class="avatar-user" v-if="treeData.company_avatar">
									<div class="user-circle" v-else>
										<icon-user/>
									</div>
								</div>
								<div class="data">
									<div class="name">{{ treeData.company_name }}</div>
								</div>
							</div>
						</div>
					</div>

					<!-- CHILD LIGHT GREY -->
					<div class="box-tbf department-box" :class="{'compact-department': densityType == 'compact', 'detailed-department': densityType == 'detailed'}" v-if="treeData.type == 'department'">
						<div class="content-box" :class="{'with-responsible': treeData.responsible && densityType != 'structural', 'with-color': treeData.color_code}" :style="`--color: ${treeData.color_code};`">
							<div class="header-box">
								<div class="box-type">
									{{$t('tree-chart.department')}}
								</div>
								<div class="box-actions">
									<v-popover class="counter" :disabled="$resize && $mq.below(780)" offset="2" trigger="hover" placement="bottom" popoverBaseClass="popover-tbf btn-animated" :delay="{show: 0, hide: 0}">
										<div class="counter"><span class="text">{{ treeData.people }}</span></div>

										<template slot="popover">
											<div class="simple-text">{{ $tc('tree-chart.employees',treeData.people) }}</div>
										</template>
									</v-popover>
								</div>
							</div>
							<div class="title-department">
								<v-popover offset="2" trigger="hover" placement="bottom" popoverBaseClass="popover-tbf" :disabled="!treeData.description || $resize && $mq.below(780)" :delay="{show: 200, hide: 0}">
									<span class="text" @click="goToDepartment(treeData.slug)">{{ treeData.name }}</span>

									<template slot="popover">
										<div class="simple-text">{{ treeData.description }}</div>
									</template>
								</v-popover>
							</div>
						</div>
						<div class="content-box department-responsible" :class="{'compact': densityType == 'compact', 'detailed': densityType == 'detailed', 'with-color': treeData.color_code}" :style="`--color: ${treeData.color_code};`" v-if="treeData.responsible && densityType != 'structural'">
							<div v-if="treeData.responsible.date_of_birth && moment(treeData.responsible.date_of_birth).format('DD-MM') == moment().format('DD-MM')" class="birthdayIcons responsible">
								<v-popover offset="5" trigger="hover" placement="bottom" popoverBaseClass="popover-tbf" class="label" :delay="{show: 100, hide: 0}" >
									<img src="/build/images/ConeConfetti.png" class="icon"/>
									<div slot="popover">
										<div class="simple-text" v-if="$auth.user().id == treeData.responsible.id">{{ $t('show_user.birthday.toYou')}}</div>
										<div class="simple-text" v-else>{{ $t('show_user.birthday.toHim')}}</div>
									</div>
								</v-popover>
							</div>
							<div class="line"></div>
							<div class="header-box">
								<div class="box-type" v-bind:class="treeData.responsible.free_day ? 'employee-gone' : ''">
									{{ treeData.responsible.free_day ? $t('tree-chart.employee_gone') : $t('tree-chart.responsible')}}
								</div>
							</div>

							<div class="user-data" :class="{'employee-gone': treeData.responsible.free_day, 'compact': densityType == 'compact', 'detailed': densityType == 'detailed'}">
								<div class="avatar">
									<img :src="treeData.responsible.avatar.lastIndexOf('gravatar') >= 0 ? treeData.responsible.avatar : `/build${treeData.responsible.avatar.substring(treeData.responsible.avatar.lastIndexOf('.ro')+3)}`" class="avatar-user" v-if="treeData.responsible.avatar">
									<div class="user-circle" v-else>
										<icon-user/>
									</div>
								</div>
								<div class="data" :class="{'compact': densityType == 'compact', 'detailed': densityType == 'detailed'}">
									<v-popover :disabled="$resize && $mq.below(780)" offset="5" trigger="hover" placement="bottom" popoverBaseClass="popover-tbf" :delay="{show: 200, hide: 0}">
										<div class="name">{{ treeData.responsible.first_name + ' ' +  treeData.responsible.last_name }}</div>
										<div class="roles" v-if="treeData.responsible.job_function">{{ treeData.responsible.job_function }}</div>
										<div class="roles" v-else><span v-for="(role, index) in treeData.responsible.roles"><span>{{role.name}}</span><span v-if="index+1 < treeData.responsible.roles.length">, </span></span></div>

										<template slot="popover">
											<div class="title">{{ treeData.responsible.first_name + ' ' +  treeData.responsible.last_name }}</div>
											<div class="info-text"><span v-for="(role, index) in treeData.responsible.roles"><span>{{role.name}}</span><span v-if="index+1 < treeData.responsible.roles.length">, </span></span></div>
										</template>
									</v-popover>
								</div>
							</div>
						</div>
					</div>

					<div class="box-tbf" :class="[treeData.free_day ? 'employee-gone' : 'user-box', {'compact': densityType == 'compact', 'detailed': densityType == 'detailed', 'with-color': treeData.color_code }]" :style="`--color: ${treeData.color_code};`" v-if="treeData.type == 'user'">
						<div class="line"></div>
						<div class="content-box">
							<div v-if="treeData.date_of_birth && moment(treeData.date_of_birth).format('DD-MM') == moment().format('DD-MM')" class="birthdayIcons">
								<v-popover offset="5" trigger="hover" placement="bottom" popoverBaseClass="popover-tbf" class="label" :delay="{show: 100, hide: 0}" >
									<img src="/build/images/ConeConfetti.png" class="icon"/>
									<div slot="popover">
										<div class="simple-text" v-if="$auth.user().id == treeData.id">{{ $t('show_user.birthday.toYou')}}</div>
										<div class="simple-text" v-else>{{ $t('show_user.birthday.toHim')}}</div>
									</div>
								</v-popover>
							</div>
							<div class="header-box">
								<div class="box-type" v-bind:class="treeData.free_day ? 'employee-gone' : ''">
									{{ treeData.free_day ? $t('tree-chart.employee_gone') : $t('tree-chart.employee')}}
								</div>
							</div>

							<div class="user-data" :class="{'employee-gone': treeData.free_day, 'compact': densityType == 'compact', 'detailed': densityType == 'detailed'}">
								<div class="avatar">
									<img :src="treeData.avatar.lastIndexOf('gravatar') >= 0 ? treeData.avatar : `/build${treeData.avatar.substring(treeData.avatar.lastIndexOf('.ro')+3)}`" class="avatar-user" v-if="treeData.avatar">
									<div class="user-circle" v-else>
										<icon-user/>
									</div>
								</div>
								<div class="data" :class="{'compact': densityType == 'compact', 'detailed': densityType == 'detailed'}">
									<v-popover :disabled="$resize && $mq.below(780)" offset="5" trigger="hover" placement="bottom" popoverBaseClass="popover-tbf" :delay="{show: 200, hide: 0}">
										<div class="name">{{ treeData.first_name + ' ' +  treeData.last_name }}</div>
										<div class="roles" v-if="treeData.job_function">{{ treeData.job_function }}</div>
										<div class="roles" v-else><span v-for="(role, index) in treeData.roles"><span>{{role.name}}</span><span v-if="index+1 < treeData.roles.length">, </span></span></div>
										<template slot="popover">
											<div class="title">{{ treeData.first_name + ' ' +  treeData.last_name }}</div>
											<div class="info-text"><span v-for="(role, index) in treeData.roles"><span>{{role.name}}</span><span v-if="index+1 < treeData.roles.length">, </span></span></div>
										</template>
									</v-popover>
								</div>
							</div>
						</div>
					</div>

					<div class="box-tbf vacant-job-box" v-if="treeData.type == 'vacant_job'">
						<div class="content-box">
							<div class="header-box">
								<div class="box-type">
									{{$t('tree-chart.vacant_job')}}
								</div>
							</div>

							<div class="user-data">
								<div class="data">
									<v-popover :disabled="$resize && $mq.below(780)" offset="5" trigger="hover" placement="bottom" popoverBaseClass="popover-tbf" :delay="{show: 200, hide: 0}">
										<div class="name">{{ treeData.name }}</div>
										<div class="roles"><span v-for="(role, index) in treeData.roles"><span>{{role.name}}</span><span v-if="index+1 < treeData.roles.length">, </span></span></div>

										<template slot="popover">
											<div class="title">{{ treeData.name }}</div>
											<div class="info-text">{{ treeData.description ? treeData.description : '' }}</div>
										</template>
									</v-popover>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="extend-handle-tbf" :class="{open: !parentOpen}" @click="toggleExtend(treeData)" v-if="treeData.children && treeData.children.length > 0 && checkChildrenFilters(treeData.children)"></div>
			</td>
		</tr>
		<tr v-if="treeData.children && treeData.extend && checkChildrenFilters(treeData.children)" class="children-row-wrapper">
			<td v-for="(children, index) in treeData.children"
				:key="index"
				colspan="2"
				class="childLevel"
				v-if="checkUserFilters(children)"
				:class="[{'single-user': treeData.type == 'user' && children.type == 'user'}, {department: children.type == 'department'}, treeData.type == 'department' && children.type == 'user' ? `color${treeData.id}` : '' ]"
			>
				<PublicTreeChart :json="children" :zoomPage="zoomPage" :filters="filters" @click-node="$emit('click-node', $event)" :promises="promises" :densityType="densityType"/>
			</td>
		</tr>
	</table>
</template>

<script>
	import EditDotsIcon from "../../Icons/EditDots";
	import IconUser from '../../Icons/User'
	import IconDepartment from '../../Icons/Department'
	import IconTrash from '../../Icons/Trash'
	import IconEdit from '../../Icons/Edit'
	import IconEmail from '../../Icons/Email'
	import IconPhone from '../../Icons/Phone'
	import IconCake	from '../../Icons/BirthdayCake'
	import IconBuilding from '../../Icons/Building'
	import IconSkills from '../../Icons/Skill'
	import IconPipe from '../../Icons/Pipe'
	import IconHourglass from '../../Icons/Hourglass'

export default {
	data() {
		return {
			treeData: {},
			parentOpen: false,
			filtersUser: {}
		};
	},
  	props: {
  		json: Object,
  		zoomPage: Number,
  		filters: Object,
  		promises: Object,
		densityType: String
  	},
  	name: "PublicTreeChart",
	components: {
		EditDotsIcon,
		IconUser,
		IconDepartment,
		IconTrash,
		IconEdit,
		IconEmail,
		IconPhone,
		IconCake,
		IconBuilding,
		IconSkills,
		IconPipe,
		IconHourglass,
	},
	watch: {
		json: {
			handler: function(Props) {
				let extendKey = function(jsonData) {
					var jsonExtend = localStorage.getItem('jsonExtend') ? JSON.parse(localStorage.getItem('jsonExtend')) : [];

					if(jsonExtend.find(el => el.id == jsonData.id)){
						jsonData.extend = jsonExtend.find(el => el.id == jsonData.id).extend
					}else{
						jsonData.extend = true
						jsonExtend.push({ id: jsonData.id, extend: jsonData.extend })
					}
					localStorage.setItem('jsonExtend', JSON.stringify(jsonExtend))

					return jsonData;
				};
				if(Props) {
					if(typeof Props === 'object'){
						this.treeData = extendKey(Props);
					}
				}
			},
			immediate: true,
		},
		filters: {
			immediate: true,
			deep: true,
			handler (val) {
				this.filtersUser = val
			}
		}
	},
	mounted(){
		this.$root.$on('toggleExtendAll', (valueExtend) => {
			this.treeData = extendKey2(this.treeData, valueExtend);
			this.$forceUpdate()

			var noCountExntend = 0
			localStorage.setItem('numberCount', (noCountExntend ? noCountExntend = parseInt(noCountExntend) + 1 : 1))
		})

		function extendKey2(jsonData, extendValue) {
			var jsonExtend = localStorage.getItem('jsonExtend') ? JSON.parse(localStorage.getItem('jsonExtend')) : [];

			jsonData.extend = extendValue
			if(jsonExtend.find(el => el.id == jsonData.id)){
				jsonExtend.find(el => el.id == jsonData.id).extend = jsonData.extend
			}else{
				jsonExtend.push({ id: jsonData.id, extend: jsonData.extend })
			}
			localStorage.setItem('jsonExtend', JSON.stringify(jsonExtend))

			return jsonData;
		};

		var noCount = localStorage.getItem('numberCount')
		localStorage.setItem('numberCount', (noCount ? noCount = parseInt(noCount) + 1 : 1))

		if(noCount == localStorage.getItem('numberCountExtend')){
			this.centerOrg()
		}
	},
  	methods: {
		goToDepartment(slug){
			this.$router.push({ name: 'public_department', params: {slug:slug, uuid: this.$route.params.uuid} })
		},
		toggleExtend: function(treeData) {
			var jsonExtend = localStorage.getItem('jsonExtend') ? JSON.parse(localStorage.getItem('jsonExtend')) : [];
			treeData.extend = !treeData.extend;
			jsonExtend.find(el => el.id == treeData.id).extend = treeData.extend
			localStorage.setItem('jsonExtend', JSON.stringify(jsonExtend))

			this.parentOpen = !this.parentOpen;
			this.$forceUpdate();
		},
		centerOrg(){
			var calcWidth = ($('.scrollable-chart .center-box .parentLevel').first().children('.node').position().left * this.zoomPage) - ($(window).width() / 2) + (($('.scrollable-chart .center-box .parentLevel').first().children('.node').width() / 2) * this.zoomPage) + 30

			$('.scrollable-chart').animate({
				scrollTop: $('.scrollable-chart').offset().top - $(window).height()/2,
				scrollLeft: calcWidth
			}, 300);
		},
		checkUserFilters(children){
			if(children.type == 'user' || children.type == 'vacant_job'){
				//Check Filter Role
				var existRole = true
				if(this.filtersUser.role.length){
					existRole = false
					children.roles.map(el => {
						if(this.filtersUser.role.some(role => role.id == el.id)){
							existRole = true
						}
					})
				}
				//Check Filter Workstation
				var existWorkstation = true
				if(this.filtersUser.workstation.length){
					existWorkstation = false
					if(this.filtersUser.workstation.some(workstation => workstation.id == children.workstation_id)){
						existWorkstation = true
					}
				}
				//Check Filter Work Schedule
				var existWorkSchedule = true
				if(this.filtersUser.work_schedule.length){
					existWorkSchedule = false
					if(this.filtersUser.work_schedule.some(work_schedule => work_schedule.id == children.work_schedule_id)){
						existWorkSchedule = true
					}
				}
				//Check Filter Skill
				var existSkill = true
				if(this.filtersUser.skill.length){
					existSkill = false
					children.skills_ids.map(el => {
						if(this.filtersUser.skill.some(skill => skill.id == el)){
							existSkill = true
						}
					})
				}
				//Check Filter Language
				var existLanguage = true
				if(this.filtersUser.language.length){
					existLanguage = false
					children.languages_ids.map(el => {
						if(this.filtersUser.language.some(language => language.id == el)){
							existLanguage = true
						}
					})
				}

				if(existRole && existWorkstation && existWorkSchedule && existSkill && existLanguage && this.densityType != 'structural'){
					return true
				}else{
					return false
				}
			}else{
				return true
			}
		},
		checkChildrenFilters(childrens){
			var canView = false

			childrens.every(el => {
				canView = this.checkUserFilters(el)
			})

			return canView
		},
		workingSince(date){
			var a = moment()
			var b = moment(date)

			var years = a.diff(b, 'year');
			b.add(years, 'years');

			var months = a.diff(b, 'months');
			b.add(months, 'months');

			var days = a.diff(b, 'days');

			if( years != 0) {
				return `${this.$tc('tree-chart.years', years)} ${this.$tc('tree-chart.months', months)}`
			} else {
				return `${this.$tc('tree-chart.months', months)} ${this.$tc('tree-chart.days', days)}`
			}
		}
  	}
};
</script>
